import { createContext, useContext } from 'react';

export const PayAccessFeeContext = createContext<string>('');

export const usePayAccessPreviewSpaceId = () => {
  return useContext(PayAccessFeeContext);
};
